"use strict";
require('../customers/CompanyCustomersService.js');
require('../checklist/CompanyChecklistService.js');
require('../CompanyService.js');
require('../publications/order/CompanyPublicationOrderService.js');
require('../publications/CompanyPublicationService.js');
require('../CompanyQueriesService.js');
require('../timestamps/CompanyTimestampsService.js');
require('../timestamps/CompanyCustomerTimestampsHistoryCtrl.js');
require('../publications/CompanyPublicationMassEditCtrl.js');
require('../groups/CompanyGroupService.js');
require('../object-skills/CompanyObjectSkillsCtrl.js');
require('../object-skills/CompanyObjectSkillsService.js');
require('../skills/CompanySkillsService.js');

CompanyCustomerDetailCtrl.$inject = [
  '$scope',
  '$stateParams',
  '$state',
  '$modal',
  '$http',
  '$sce',
  '$filter',
  'CompanyCustomersService',
  'customer',
  'checklists',
  'addresses',
  'currentUser',
  'CompanyChecklistService',
  'CompanyPublicationOrderService',
  'CompanyPublicationService',
  'files',
  '$translate',
  'config',
  'info',
  'UploadTracker',
  'CompanyQueriesService',
  'CompanyGroupService',
  'CompanyCustomerService',
  'CompanyTimestampsService',
  'CompanyPublicationService',
  'CompanySettingUnitsService',
  'CompanyService',
  'growl',
  'services',
  'priorities',
  'customerUnits',
  'objectSkills',
  'priceLists'
];

function CompanyCustomerDetailCtrl(
  $scope,
  $stateParams,
  $state,
  $modal,
  $http,
  $sce,
  $filter,
  CompanyCustomersService,
  customer,
  checklists,
  addresses,
  currentUser,
  checklistService,
  orderService,
  publicationService,
  files,
  $translate,
  config,
  info,
  uploadTracker,
  CompanyQueriesService,
  CompanyGroupService,
  CompanyCustomerService,
  CompanyTimestampsService,
  CompanyPublicationService,
  CompanySettingUnitsService,
  CompanyService,
  growl,
  services,
  priorities,
  customerUnits,
  objectSkills,
  priceLists
) {

  $scope.customer = customer;
  $scope.origCustomer = angular.copy(customer);
  $scope.files = files;
  $scope.checklists = checklists;
  $scope.services = services;
  $scope.addresses = addresses;
  $scope.priceLists = priceLists;
  $scope.info = info;
  $scope.customerUnits = customerUnits;
  $scope.objectSkills = objectSkills;
  $scope.limitCustomerCategories = 20;
  $scope.newComment = {
    text: ''
  };
  $scope.tabs = [
    {
      'title': 'information',
      'content': '',
      'template': 'partials/company/customers-dashboard/detail/information.html',
      'icon': 'info-circle'
    },
    {
      'title': 'more-info',
      'content': '',
      'template': 'partials/company/customers-dashboard/detail/more-info.html',
      'icon': 'question-circle'
    }
  ];
  if($scope.customer.extra.group){
    $scope.tabs.push({
      'title': 'customer-portal.customer-portal',
      'content': '',
      'template': 'partials/company/customers-dashboard/detail/portal.html',
      'icon': 'laptop'
    });
    $scope.priorities  = priorities;

    CompanyGroupService.get({
      companyId: $stateParams.companyId,
      groupId: $scope.customer.extra.group.id
    }).$promise.then(function(customerPortal){
      $scope.customerPortal = customerPortal;
      CompanyPublicationService.query({
        companyId: $stateParams.companyId,
        groupId: $scope.customer.extra.group.id,
        limit: customerPortal.numPublications
      }, function(publications){
        $scope.publications = publications;
      });
    });

    $scope.removePublication = function(publication) {
      if (publication.groups.indexOf($scope.customerPortal.id) > -1) {
        publication.groups.splice(publication.groups.indexOf($scope.customerPortal.id), 1);
      }
      CompanyPublicationService.update({companyId: $stateParams.companyId, publicationId: publication.id}, publication, function() {
        growl.addSuccessMessage($translate.instant('customer-portals.remove-publication-success'));
        $scope.publications.splice($scope.publications.indexOf(publication), 1);
      }, function() {
        growl.addErrorMessage($translate.instant('customer-portals.remove-publication-failure'));
      });
    };

    $scope.setPriority = function(publication, priority) {
      var indexPublication = $scope.publications.indexOf(publication);
      if( ! priority) {
        $scope.publications[indexPublication].priority = null;
      } else {
        $scope.publications[indexPublication].priority = priority;
      }

      return $scope.savePublication($scope.publications[indexPublication]);
    };

    $scope.prioritiesSorted = ($filter('orderBy')($scope.priorities, 'stepNr')).filter(function(v){
      return v.stepNr > 0;
    });

    $scope.nextStatus = function(publication) {
      var indexPublication = $scope.publications.indexOf(publication);
      if ($scope.prioritiesSorted.length === 0) {
        return;
      }
      if (!$scope.publications[indexPublication].priority) {
        $scope.publications[indexPublication].priority = $scope.prioritiesSorted[0];
        $scope.savePublication($scope.publications[indexPublication]);
      } else {
        var index = $scope.prioritiesSorted.findIndex(function(v){
          return v.id === $scope.publications[indexPublication].priority.id;
        });

        if (index >= ($scope.prioritiesSorted.length - 1) || index < 0) {
          return;
        }

        $scope.publications[indexPublication].priority = $scope.prioritiesSorted[index + 1];
        $scope.savePublication($scope.publications[indexPublication]);
      }
    };

    $scope.publicationsMassEdit = [];
    $scope.namePublications = [];
    $scope.addPublicationsMassEdit = function(publication, publicationSelected){
      if(publicationSelected){
        $scope.publicationsMassEdit.push(publication.id);
        $scope.namePublications.push(publication);
      }else{
        $scope.publicationsMassEdit.splice($scope.publicationsMassEdit.indexOf(publication.id), 1);
        $scope.namePublications.splice($scope.namePublications.indexOf(publication), 1);
      }
    };

    $scope.selectAllPublication = function(){
      $scope.selectAll = !$scope.selectAll;
      angular.forEach($scope.publications, function(publication){
        if($scope.selectAll){
          publication.selected = true;
          $scope.publicationsMassEdit.push(publication.id);
          $scope.namePublications.push(publication);
        }else{
          publication.selected = false;
          $scope.publicationsMassEdit = [];
          $scope.namePublications = [];
        }
      });
    };

    $scope.showModalMassEdit = function() {
      $modal({
        scope: $scope,
        controller: 'CompanyPublicationMassEditCtrl',
        templateUrl: 'partials/company/publications/lists/mass-edit-modal.html',
        show: true,
        resolve: {
          priorities: function() {
            return priorities;
          },
          groups: ['$stateParams', 'CompanyGroupService', function ($stateParams, CompanyGroupService) {
            return CompanyGroupService.query({
              companyId: $stateParams.companyId,
              all: true
            }).$promise;
          }],
          categories: ['$stateParams', 'CompanyCategoryService', function ($stateParams, CompanyCategoryService) {
            return CompanyCategoryService.query({
              companyId: $stateParams.companyId,
              limit: 1000
            }).$promise;
          }]
        }
      });
    };
  }

  $scope.showModalEditSkills = function() {
    $modal({
      scope: $scope,
      controller: 'CompanyObjectSkillsCtrl',
      templateUrl: 'partials/company/object-skills/modal-object-skills.html',
      show: true,
      resolve: {
        object: function() {
          return customer;
        },
        objectType: function() {
          return 'SKILL_CUSTOMER';
        },
        skills: ['$stateParams', 'CompanySkillsService', function ($stateParams, CompanySkillsService) {
          return CompanySkillsService.query({
            companyId: $stateParams.companyId,
            limit: 1000
          }).$promise;
        }]
      }
    });
  };

  $scope.searchUnits = function(filter) {
    CompanySettingUnitsService.query({companyId: $scope.companyId, limit: 10}).$promise.then(function(units) {
      return units.filter(function(item) {
        return item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1 && !$scope.customerUnits.some(function(i) {
          return item.id === i.id;
        });
      });
    }).then(function(nonUnits) {
      $scope.units = nonUnits;
    });
  };

  $scope.updateUnit = function(unit) {
    CompanySettingUnitsService.update({
      companyId: $stateParams.companyId,
      unitId: unit.id
    }, unit, function() {
      growl.addSuccessMessage($translate.instant('units.saved-success'));
      if(unit.customer === null){
        $scope.customerUnits.splice($scope.customerUnits.indexOf(unit), 1);
        if($scope.units){
          $scope.units.push(unit);
        }
      }else{
        if(unit.customer.id === $scope.customer.id){
          $scope.customerUnits.push(unit);
          $scope.units.splice($scope.units.indexOf(unit), 1);
        }
      }
    }, function() {
      growl.addErrorMessage($translate.instant('units.saved-failure'));
    });
  };

  if ($scope.currentUserPermissions.CompanyServiceView && info.features.companyService) {
    $scope.comments = [];
    $scope.editFlags = [];
    if ($scope.services.length > 0) {
      angular.forEach($scope.services, function(v){
        CompanyTimestampsService.query({
          companyId: $stateParams.companyId,
          objectId: v.id,
          limit: 21,
          offset: 0
        }, function(resp){
          v.timestamps = resp;
          var timestampCurrent = resp.filter(function(item){
            return item.status === 'IN_PROGRESS';
          });
          if(timestampCurrent.length > 0){
            v.timestampCurrent = timestampCurrent[0];
            v.monthTotal = 0;
            CompanyTimestampsService.queryTotalTime({
              companyId: $stateParams.companyId,
              objectId: v.id,
              sum: v.monthTotal
            }, function(resp){
              v.totalTime =  (new Date(timestampCurrent[0].startAt)) - (resp.total * 1000);
            });
          }else{
            v.totalTime = 0;
          }
        });
        $scope.tabs.push({
          'title': v.name,
          'content': '',
          'template': 'partials/company/customers-dashboard/detail/service.html',
          'icon': 'square',
          'color': v.color
        });

        CompanyCustomerService.queryComments({
          companyId: $stateParams.companyId,
          customerId: $stateParams.customerId,
          serviceId: v.id,
          limit: 11,
          offset: 0
        }, function(resp){
          var data = {page: 0, hasMore: false};
          if (resp.length === 11) {
            data.hasMore = true;
            resp.pop();
          }
          data.comments = resp;

          $scope.comments[v.id] = data;
        });

        $scope.editFlags[v.id] = {
          showForm: false
        };

        checklistService.query({
          companyId: $stateParams.companyId,
          relativeID: v.id
        }, function(checklist){
          v.serviceChecklist = checklist;
        });

      });
    }

    $scope.queryTotalTimeOption = function(service){
      CompanyTimestampsService.queryTotalTime({
        companyId: $stateParams.companyId,
        objectId: service.id,
        sum: service.monthTotal
      }, function(resp){
        $scope.services[$scope.services.indexOf(service)].totalTime =  (new Date(service.timestampCurrent.startAt)) - (resp.total * 1000);
      });
    };

    $scope.commentPaging = function(service, resetPage) {
      CompanyCustomerService.queryComments({
        companyId: $stateParams.companyId,
        customerId: $stateParams.customerId,
        serviceId: service.id,
        limit: 11,
        offset: resetPage ? 0 : $scope.comments[service.id].page * 10
      }, function(resp){
        if (resp.length === 11) {
          $scope.comments[service.id].hasMore = true;
          resp.pop();
        } else {
          $scope.comments[service.id].hasMore = false;
        }
        $scope.comments[service.id].comments = resp;
      });
    };

    if ($scope.currentUserPermissions.CompanyServiceCreate) {
      $scope.tabs.push({
        'content': '',
        'template': 'partials/company/customers-dashboard/detail/service-new.html',
        'icon': 'plus'
      });

      $scope.services.push({
        name: '',
        buttons: [],
        fields: [],
        color: 1666198,
      });
    }

    $scope.updateService = function(service) {
      if (service.hasOwnProperty('id')) {
        service.$update({
          companyId: $stateParams.companyId,
          customerId: $stateParams.customerId,
          serviceId: service.id
        }, function(){
          growl.addSuccessMessage($translate.instant('customer.service.save-success'));
        });
      } else {
        if (!$scope.currentUserPermissions.CompanyServiceCreate) {
          return;
        }

        service.customer = angular.copy(customer);
        CompanyCustomerService.save({
          companyId: $stateParams.companyId,
          customerId: $stateParams.customerId
        }, service, function(){
          growl.addSuccessMessage($translate.instant('customer.service.create-success'));
          $state.reload();
        });
      }
    };

    $scope.addComment = function(service, text, defaultCmt) {
      if (!text) {
        return;
      }
      CompanyCustomerService.createComment({
        companyId: $stateParams.companyId,
        customerId: $stateParams.customerId,
        serviceId: service.id
      }, {text: text, isButtonComment: defaultCmt}, function(resp){
        $scope.comments[service.id].comments.unshift(resp);
        $scope.newComment.text = '';
        if($scope.comments[service.id].comments.length > 10) {
          $scope.comments[service.id].comments = $scope.comments[service.id].comments.slice(0, 10);
          $scope.comments[service.id].hasMore = true;
        }
      });
    };

    $scope.addCommentOnEnter = function(evt, service) {
      if(evt.keyCode === 13) {
        $scope.addComment(service, $scope.newComment.text, false);
      }
    };

    $scope.deleteService = function(service) {
      if (!$scope.currentUserPermissions.CompanyServiceDelete) {
        return;
      }

      CompanyCustomerService.delete({
        companyId: $stateParams.companyId,
        customerId: $stateParams.customerId,
        serviceId: service.id
      }, function() {
        growl.addSuccessMessage($translate.instant('customer.service.delete-success'));
        $state.reload();
      });
    };

    $scope.addDefaultComment = function(service) {
      $scope.addComment(service, $translate.instant('customer.service.i-have-contact-customer'), true);
    };

    $scope.setCustomerServiceTimestamp = function(service, index){
      var serviceObject = {
        object: {
          id: service.id,
          name: service.name
        },
        objectType: 'CUSTOMER_SERVICE'
      };
      CompanyTimestampsService.save({
        companyId: $stateParams.companyId
      }, serviceObject, function(resp){
        growl.addSuccessMessage($translate.instant('timestamp.started-timestamp-success'));
        $scope.services[index].timestamps.push(resp);
        $scope.services[index].timestampCurrent = resp;
        $scope.services[index].monthTotal = 0;
        CompanyTimestampsService.queryTotalTime({
          companyId: $stateParams.companyId,
          objectId: service.id,
          sum: 0
        }, function(respTotal){
          $scope.services[index].totalTime =  (new Date(resp.startAt)) - (respTotal.total * 1000);
        });
      }, function(err){
        if(err.status === 400){
          growl.addErrorMessage(err.data);
        }
        if(err.status === 403){
          growl.addErrorMessage(err.data.error.message);
        }
      });
    };

    $scope.$on('eventServiceTimestamp', function(event, data) {
      $scope.$apply(function() {
        var eventService = $scope.services.filter(function(service){
          return service.id === data.timeStamp.object.id;
        })[0];
        var index = $scope.services.indexOf(eventService);
        if(data.action === 'SERVICE_TIMESTAMP_STARTED'){
          $scope.services[index].timestamps.push(data.timeStamp);
          $scope.services[index].timestampCurrent = data.timeStamp;
          $scope.services[index].monthTotal = 0;
          CompanyTimestampsService.queryTotalTime({
            companyId: $stateParams.companyId,
            objectId: data.timeStamp.object.id,
            sum: 0
          }, function(respTotal){
            $scope.services[index].totalTime =  (new Date(data.timeStamp.startAt)) - (respTotal.total * 1000);
          });
        }else{
          $scope.services[index].timestampCurrent = null;
          angular.forEach($scope.services[index].timestamps, function(value){
            if(value.status === 'IN_PROGRESS'){
              value.status = 'APPROVED';
              value.endedAt = new Date();
              return;
            }
          });
        }
      });
    });

    $scope.endCustomerServiceTimestamp = function(service, timestampId){
      CompanyTimestampsService.update({
        companyId: $stateParams.companyId,
        timestampId: timestampId
      }, {}, function(){
        growl.addSuccessMessage($translate.instant('timestamp.ended-timestamp-success'));
        $scope.services[$scope.services.indexOf(service)].timestampCurrent = null;
        angular.forEach($scope.services[$scope.services.indexOf(service)].timestamps, function(value){
          if(value.status === 'IN_PROGRESS'){
            value.status = 'APPROVED';
            value.endedAt = new Date();
          }
        });
      }, function(){
        growl.addSuccessMessage($translate.instant('timestamp.ended-timestamp-failure'));
      });
    };

    $scope.showTimestampHistoryModal = function(service) {
      var modal = $modal({
        scope: $scope,
        controller: 'CompanyCustomerTimestampsHistoryCtrl',
        templateUrl: 'partials/company/customers-dashboard/detail/timestamp-history-modal.html',
        show: false,
        resolve: {
          service: function() {
            return service;
          }
        }
      });
      modal.$promise.then(modal.show);
    };

    $scope.viewReportAnalyticsPdf2Modal = function(viewId){
      var content =
        '<div class="reminder-detail__wrapper" tabindex="-1" role="dialog" aria-hidden="true">' +
          '<div class="modal-dialog modal-dialog-loading">' +
            '<div class="modal-content text-center">' +
              '<i class="fa fa-spinner fa-spin fa-3x"></i>' +
            '</div>' +
          '</div>' +
        '</div>';
      jQuery.fancybox.open([{
        type: 'iframe',
        iframe: {
          preload: false
        },
        padding: 0,
        margin: 0,
        content: content
      }]);
      CompanyService.createReportAnalyticsPdf2({companyId: $stateParams.companyId}, {viewId: viewId.toString(), customerName: $scope.customer.name}, function(resp) {
        $http({
          method: "GET",
          url: config.apiBase + "/files/" + resp.id
        }).then(function(response){
          var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
          var url = '';
          if (response.status === 200) {
            url = config.apiBase + '/files/' + resp.id;
          }
          if (true === iOS) {
            window.open(url, '_self');
            return;
          }
          jQuery.fancybox.open([{
            type: 'iframe',
            iframe: {
              preload: false
            },
            padding: 0,
            margin: 0,
            href: url
          }]);
        });
      }, function(err){
        jQuery.fancybox.close();
        setTimeout(function(){
          growl.addErrorMessage(err.data);
        }, 500);
      });
    };
  }

  $scope.tabs.activeTab = 0;

  if ($stateParams.tab) {
    var index = $scope.services.findIndex(function(v){
      return $stateParams.tab === v.id;
    });

    if (index > -1) {
      $scope.tabs.activeTab = index + ($scope.customer.extra.group ? 3 : 2);
    }
  }

  $scope.updateCustomer = function(customer) {
    CompanyCustomersService.update({companyId: $stateParams.companyId, customerId: $stateParams.customerId}, customer, function(){
      $scope.customer = customer;
      $scope.origCustomer = angular.copy(customer);
      growl.addSuccessMessage($translate.instant('customer.save-success'));
      $state.go('^.list', {}, {reload: true});
    }, function(){
      growl.addErrorMessage($translate.instant('customer.save-failure'));
      $scope.customer = angular.copy($scope.origCustomer);
    });
  };

  $scope.cancel = function() {
    $scope.customer = angular.copy($scope.origCustomer);
  };

  $scope.queryPublications = function(text, publications) {
    return CompanyQueriesService.queryPublications(text, publications);
  };

  $scope.onFileSelect = function(files) {
    return uploadTracker(files.map(function(f) {
      return {
        url:  config.apiBase + '/companies/' + $stateParams.companyId + '/customers/' + $stateParams.customerId + '/files',
        file: f,
      };
    })).then(function() {
      CompanyCustomersService.queryFiles({
        companyId: $stateParams.companyId,
        customerId: $stateParams.customerId
      }, function(resp){
        $scope.files = resp;
      });
    });
  };

  $scope.removeFile = function(file, index) {
    CompanyCustomersService.deleteFile({
      companyId: $stateParams.companyId,
      customerId: $stateParams.customerId,
      fileId: file
    }, function(){
      $scope.files.splice(index, 1);
    });
  };

  $scope.addAddress = function() {
    $scope.addresses.push(angular.copy($scope.defaultAddress));
  };

  $scope.saveAddress = function(address) {
    CompanyCustomersService.updateAddress({
      companyId: $stateParams.companyId,
      customerId: $stateParams.customerId
    }, address, function(){
      growl.addSuccessMessage($translate.instant('customer.save-address-success'));
    });
  };

  $scope.deleteAddress = function(address, index) {
    if (address.id !== undefined) {
      CompanyCustomersService.deleteAddress({
        companyId: $stateParams.companyId,
        customerId: $stateParams.customerId,
        addressId: address.id
      }, function(){
        $scope.addresses.splice(index, 1);
        growl.addSuccessMessage($translate.instant('customer.delete-address-success'));
      });
    } else {
      $scope.addresses.splice(index, 1);
    }
  };

  $scope.addObject = function(object) {
    CompanyCustomersService.addObject({
      companyId: $stateParams.companyId,
      customerId: $scope.customer.id
    }, {
      object: {
        id: object.id,
        name: object.name
      }
    }, function(){
      $scope.addedPublication = null;
      $scope.customer.objects.push(object);
      growl.addSuccessMessage($translate.instant('customer.save-success'));
    }, function(){
      growl.addErrorMessage($translate.instant('customer.save-failure'));
    });
  };

  $scope.deleteConnectedObject = function(object, index) {
    CompanyCustomersService.removeObject({
      companyId: $stateParams.companyId,
      customerId: $scope.customer.id,
      objectId: object.id
    }, function(){
      $scope.customer.objects.splice(index, 1);
      growl.addSuccessMessage($translate.instant('customer.save-success'));
    }, function(){
      growl.addErrorMessage($translate.instant('customer.save-failure'));
    });
  };

  $scope.checkCategory = function(id, selected) {
    if(selected === true){
      $scope.customer.categoryIds.push(id);
    }else{
      $scope.customer.categoryIds.splice($scope.customer.categoryIds.indexOf(id), 1);
    }
  };

  $scope.inputTags = angular.copy($scope.customer.tags);
  $scope.convertTags = function() {
    var newTags = [];
    newTags = $scope.inputTags.map(function(tag) { return tag.text; });
    angular.copy(newTags, $scope.customer.tags);
  };

  $scope.loadTags = function() {
    return CompanyService.queryTags({companyId: $stateParams.companyId}).$promise;
  };

  $scope.createLinkPortal = function() {
    var customerPortal = new CompanyGroupService({
      type: 'VISIBLE',
      name: customer.name,
      extra: {
        customer: {
          id: $scope.customer.id,
          name: $scope.customer.name
        }
      }
    });
    customerPortal.$save({companyId: $stateParams.companyId, type: 'VISIBLE'}, function(resp, headers) {
      var newId = headers('Location').split('/').pop();
      $state.go('root.company.customerPortals.detail', {companyId: $stateParams.companyId, customerPortalId: newId});
      growl.addSuccessMessage($translate.instant('customer-portal.create-success'));
    }, function(){
      growl.addSuccessMessage($translate('customer-portal.create-failure'));
    });
  };

  $scope.filePreview = function(file) {
    CompanyCustomersService.fileToken({companyId: $stateParams.companyId, customerId: $scope.customer.id, fileId: file.id}, {}, function(response) {

      var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
      var url = config.apiBase + '/companies/' + $scope.companyId + '/customers/' + $scope.customer.id + '/files/' + file.id + '/raw?token=' + response.token;

      var type;
      switch(file.mimeType) {
        case 'image/jpeg':
        case 'image/png':
        case 'image/gif':
        case 'image/bmp':
        case 'image/svg+xml':
        case 'image/webp':
          type = 'image';
          break;
        case 'application/pdf':
          if (true === iOS) {
            window.open(url, '_self');
            return;
          }
          type = 'iframe';
          break;
        default:
          type = 'iframe';
      }

      jQuery.fancybox.open([{
        type: type,
        iframe: {
          preload: false
        },
        padding: 0,
        margin: 0,
        href: url
      }]);
    });

    return false;
  };

  $scope.downloadFile = function(file) {
    CompanyCustomersService.fileToken({companyId: $stateParams.companyId, customerId: $scope.customer.id, fileId: file.id}, {}, function(response) {
      var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
      if (true === iOS) {
        window.open(config.apiBase + '/companies/' + $scope.companyId + '/customers/' + $scope.customer.id + '/files/' + file.id + '/raw?token=' + response.token + '&download=true', '_self');
        return;
      }

      var elm = angular.element(document.querySelector('body'));
      var iFrame = elm.find('#downloadWindow');
      if (!(iFrame && iFrame.length > 0)) {
        iFrame = angular.element("<iframe id='downloadWindow' style='position:fixed;display:none;top:-1px;left:-1px;'/>");
        elm.append(iFrame);
      }

      iFrame.attr('src', config.apiBase + '/companies/' + $scope.companyId + '/customers/' + $scope.customer.id + '/files/' + file.id + '/raw?token=' + response.token + '&download=true');
    });
  };
}

CompanyCustomerDetailCtrl.resolve = {
  customer: ['$stateParams', 'CompanyCustomersService', function($stateParams, CompanyCustomersService) {
    return CompanyCustomersService.get({
      companyId: $stateParams.companyId,
      customerId: $stateParams.customerId}).$promise;
  }],
  customerUnits: ['$stateParams', 'CompanyCustomersService', function($stateParams, CompanyCustomersService){
    return CompanyCustomersService.queryUnits({
      companyId: $stateParams.companyId,
      customerId: $stateParams.customerId, 
      limit: 10
    }).$promise;
  }],
  objectSkills: ['$stateParams', 'CompanyObjectSkillsService', function($stateParams, CompanyObjectSkillsService){
    return CompanyObjectSkillsService.query({
      companyId: $stateParams.companyId,
      objectType: 'SKILL_CUSTOMER',
      objectID: $stateParams.customerId, 
      limit: 1000
    }).$promise;
  }],
  files: ['$stateParams', 'CompanyCustomersService', function($stateParams, CompanyCustomersService){
    return CompanyCustomersService.queryFiles({
      companyId: $stateParams.companyId,
      customerId: $stateParams.customerId
    }).$promise;
  }],
  checklists: ['$stateParams', 'CompanyChecklistService', function($stateParams, checklistService){
    return checklistService.query({
          companyId: $stateParams.companyId,
          relativeID: $stateParams.customerId
        }).$promise;
  }],
  addresses: ['$stateParams', 'CompanyCustomersService', function($stateParams, CompanyCustomersService){
    return CompanyCustomersService.queryAddresses({
      companyId: $stateParams.companyId,
      customerId: $stateParams.customerId
    }).$promise;
  }],
  services: ['$stateParams', 'CompanyCustomerService', 'customer', 'info', function($stateParams, CompanyCustomerService, customer, info){
    if (!info.features.companyService) {
      return false;
    }
    return CompanyCustomerService.query({
      companyId: $stateParams.companyId,
      customerId: customer.id
    }).$promise;
  }],
  priceLists: ['$stateParams', 'CompanyProductsService', 'info', function($stateParams, CompanyProductsService, info) {
    if (!info.features.products) {
        return false;
    }
    return CompanyProductsService.priceListQuery({companyId: $stateParams.companyId, limit: 1000}).$promise;
  }]
};

module.exports  = CompanyCustomerDetailCtrl;

angular.module("dokiv")
  .controller("CompanyCustomerDetailCtrl", CompanyCustomerDetailCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/customers-dashboard/CompanyCustomerDetailCtrl.js
// module id = 334
// module chunks = 0